/* Lana Banana theme by RiWEB scripts */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var once = function (el, key) {
    if (!el || el.dataset['init' + key]) return false;
    el.dataset['init' + key] = 'true';
    return true;
  };

  /* Light / dark switch --------------------------------------------------- */
  function initThemeToggle() {
    $$('[data-theme-toggle]').forEach(function (button) {
      if (!once(button, 'Theme')) return;
      button.addEventListener('click', function () {
        var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try { localStorage.setItem('lana-banana-theme', next); } catch (e) {}
      });
    });
  }

  function goToCart() { window.location.assign(window.theme.routes.cart); }

  /* Header: search toggle, menus, drawer ---------------------------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header || !once(header, 'Header')) return;

    var search = $('[data-header-search]', header);
    var searchToggle = $('[data-search-toggle]', header);
    if (search && searchToggle) {
      searchToggle.addEventListener('click', function () {
        var open = search.classList.toggle('is-open');
        if (open) { var input = $('input[type="search"]', search); if (input) input.focus(); }
      });
    }

    var items = $$('[data-nav-details]', header);
    var canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
    var closeAll = function (except) {
      items.forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
    };
    items.forEach(function (details) {
      var timer;
      details.addEventListener('toggle', function () { if (details.open) closeAll(details); });
      details.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(timer);
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function () {
        if (!canHover.matches) return;
        timer = setTimeout(function () { details.removeAttribute('open'); }, 120);
      });
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-nav-details]')) closeAll();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closeAll(); closeDrawer(); }
    });

    var drawer = $('[data-drawer]');
    var opener = $('[data-drawer-open]', header);
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    }
    if (drawer && opener) {
      opener.addEventListener('click', function () {
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
        var close = $('button[data-drawer-close]', drawer);
        if (close) close.focus();
      });
      $$('[data-drawer-close]', drawer).forEach(function (el) { el.addEventListener('click', closeDrawer); });
    }
  }

  /* Quantity steppers ------------------------------------------------------ */
  function initQuantity() {
    $$('[data-quantity]').forEach(function (wrap) {
      if (!once(wrap, 'Qty')) return;
      var input = $('input', wrap);
      var change = function (delta) {
        var min = parseInt(input.min, 10); if (isNaN(min)) min = 0;
        var value = (parseInt(input.value, 10) || 0) + delta;
        input.value = Math.max(min, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      $('[data-quantity-minus]', wrap).addEventListener('click', function () { change(-1); });
      $('[data-quantity-plus]', wrap).addEventListener('click', function () { change(1); });
    });
  }

  /* Cart drawer ------------------------------------------------------------- */
  var cartDrawerReturnFocus = null;
  function getCartDrawer() { return $('[data-cart-drawer]'); }
  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function renderCartDrawer(html) {
    var drawer = getCartDrawer();
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = $('[data-cart-drawer-content]', doc);
    var target = $('[data-cart-drawer-content]', drawer);
    if (!source || !target) return;
    target.innerHTML = source.innerHTML;
    setCartCount(parseInt(source.dataset.itemCount, 10) || 0);
    initQuantity();
  }
  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) { goToCart(); return; }
    cartDrawerReturnFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    var panel = $('.cart-drawer__panel', drawer);
    if (panel) panel.focus();
  }
  function closeCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (cartDrawerReturnFocus && cartDrawerReturnFocus.focus) cartDrawerReturnFocus.focus();
  }
  function changeCartLine(line, quantity) {
    var drawer = getCartDrawer();
    if (drawer) drawer.classList.add('is-loading');
    return fetch(window.theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data.sections) renderCartDrawer(data.sections['cart-drawer']); })
      .catch(function () { goToCart(); })
      .then(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }
  function addToCart(form, buttons, errorEl) {
    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);
    if (errorEl) errorEl.hidden = true;
    buttons.forEach(function (b) { b.classList.add('is-loading'); });
    return fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, data: json }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || window.theme.strings.error);
        if (getCartDrawer() && result.data.sections) {
          renderCartDrawer(result.data.sections['cart-drawer']);
          openCartDrawer();
        } else {
          goToCart();
        }
      })
      .catch(function (err) {
        var message = err.message || window.theme.strings.error;
        if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; } else { window.alert(message); }
      })
      .then(function () { buttons.forEach(function (b) { b.classList.remove('is-loading'); }); });
  }
  window.theme.addItems = function (items) {
    var fd = new FormData();
    items.forEach(function (it, i) { fd.append('items[' + i + '][id]', it.id); fd.append('items[' + i + '][quantity]', it.quantity || 1); });
    fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname);
    return fetch(window.theme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, data: json }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || window.theme.strings.error);
        if (getCartDrawer() && result.data.sections) { renderCartDrawer(result.data.sections['cart-drawer']); openCartDrawer(); } else { goToCart(); }
        return result;
      });
  };
  function initCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer || !once(drawer, 'CartDrawer')) return;
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-drawer-close]')) { closeCartDrawer(); return; }
      var remove = event.target.closest('[data-drawer-remove]');
      if (remove) changeCartLine(parseInt(remove.dataset.line, 10), 0);
    });
    drawer.addEventListener('change', function (event) {
      var input = event.target.closest('[data-drawer-quantity]');
      if (input) changeCartLine(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0);
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeCartDrawer(); });
    $$('.header__cart').forEach(function (link) {
      link.addEventListener('click', function (event) { event.preventDefault(); openCartDrawer(); });
    });
  }
  function initQuickAdd() {
    $$('[data-quick-add]').forEach(function (form) {
      if (!once(form, 'QuickAdd')) return;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart(form, $$('button', form), null);
      });
    });
  }

  /* Age check ---------------------------------------------------------------- */
  function initAgeGate() {
    var gate = $('[data-age-gate]');
    if (!gate || !once(gate, 'Age')) return;
    var KEY = 'lana-banana-age-ok';
    var designMode = window.Shopify && window.Shopify.designMode;
    var confirmed = false;
    try { confirmed = parseInt(localStorage.getItem(KEY), 10) > Date.now(); } catch (e) {}
    function show() {
      gate.hidden = false;
      document.body.style.overflow = 'hidden';
      var box = $('.age-gate__box', gate);
      if (box) box.focus();
    }
    function hide() { gate.hidden = true; document.body.style.overflow = ''; }
    $('[data-age-confirm]', gate).addEventListener('click', function () {
      var days = parseInt(gate.dataset.days, 10) || 30;
      try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {}
      hide();
    });
    gate.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusables = $$('button, a[href]', gate);
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    if (designMode) {
      var section = gate.closest('.shopify-section');
      document.addEventListener('shopify:section:select', function (event) { if (event.target === section) show(); });
      document.addEventListener('shopify:section:deselect', function (event) { if (event.target === section) hide(); });
    } else if (!confirmed) {
      show();
    }
  }

  /* Back to top -------------------------------------------------------------- */
  function initBackToTop() {
    var button = $('[data-back-to-top]');
    if (!button || !once(button, 'Top')) return;
    window.addEventListener('scroll', function () { button.hidden = window.scrollY < 900; }, { passive: true });
    button.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Product page ----------------------------------------------------------- */
  function initProduct(root) {
    if (!once(root, 'Product')) return;
    var sectionId = root.dataset.sectionId;
    var scope = root.closest('.shopify-section') || document;
    var form = document.getElementById(root.dataset.formId);
    var variantsEl = $('[data-variants]', root);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var picker = $('[data-variant-picker]', root);
    var stickySelect = $('[data-sticky-select]', scope);

    /* Gallery */
    var viewer = $('[data-gallery-viewer]', root);
    var thumbs = $$('[data-thumb]', root);
    function goToMedia(id, smooth) {
      if (!viewer) return;
      var slide = $('[data-media-id="' + id + '"]', viewer);
      if (!slide) return;
      viewer.scrollTo({ left: slide.offsetLeft - viewer.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }
    function markThumb(id) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goToMedia(thumb.dataset.thumb, true); markThumb(thumb.dataset.thumb); });
      /* v4: wissel ook bij muis eroverheen (alleen met een echte muis) */
      thumb.addEventListener('mouseenter', function () {
        if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) { goToMedia(thumb.dataset.thumb, false); markThumb(thumb.dataset.thumb); }
      });
    });
    if (viewer && 'IntersectionObserver' in window) {
      var slideObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) markThumb(entry.target.dataset.mediaId); });
      }, { root: viewer, threshold: 0.6 });
      $$('[data-media-id]', viewer).forEach(function (s) { slideObserver.observe(s); });
    }

    /* Lightbox */
    var lightbox = $('[data-lightbox]', scope);
    if (lightbox && typeof lightbox.showModal === 'function') {
      var zoomButtons = $$('[data-zoom]', root), lbIndex = 0;
      var lbImage = $('[data-lightbox-image]', lightbox), lbCount = $('[data-lightbox-count]', lightbox);
      function showLightbox(i) {
        if (!zoomButtons.length) return;
        lbIndex = (i + zoomButtons.length) % zoomButtons.length;
        lbImage.src = zoomButtons[lbIndex].dataset.zoom;
        if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + zoomButtons.length;
        var slide = zoomButtons[lbIndex].closest('[data-media-id]');
        if (slide) { goToMedia(slide.dataset.mediaId, false); markThumb(slide.dataset.mediaId); }
      }
      zoomButtons.forEach(function (button, i) {
        button.addEventListener('click', function () { showLightbox(i); lightbox.showModal(); });
      });
      var lbPrev = $('[data-lightbox-prev]', lightbox), lbNext = $('[data-lightbox-next]', lightbox);
      if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); showLightbox(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); showLightbox(lbIndex + 1); });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); showLightbox(lbIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); showLightbox(lbIndex - 1); }
      });
      var touchX = null;
      lightbox.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        if (touchX === null) return; var dx = e.changedTouches[0].clientX - touchX; touchX = null;
        if (Math.abs(dx) > 40) showLightbox(lbIndex + (dx < 0 ? 1 : -1));
      });
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox || event.target.closest('[data-lightbox-close]')) lightbox.close();
      });
    }

    /* Variants */
    function selectedOptions() {
      return $$('fieldset', picker).map(function (fieldset) {
        var checked = $('input:checked', fieldset);
        return checked ? checked.value : null;
      });
    }
    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (value, i) { return value === options[i]; });
      });
    }
    function markAvailability(options) {
      $$('input[type="radio"]', picker).forEach(function (input) {
        var index = parseInt(input.dataset.optionPosition, 10) - 1;
        var test = options.slice(); test[index] = input.value;
        var match = findVariant(test);
        input.classList.toggle('is-unavailable', !match || !match.available);
      });
    }
    function setButtons(variant) {
      var label = !variant ? window.theme.strings.unavailable : variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      $$('[data-add-button], [data-sticky-button]', scope).forEach(function (button) {
        button.disabled = !variant || !variant.available;
        var text = $('[data-add-button-text]', button);
        if (text) text.textContent = label;
      });
    }
    function refreshPrices(variant) {
      var url = root.dataset.url + '?variant=' + variant.id + '&section_id=' + sectionId;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-swap]', scope).forEach(function (target) {
          var source = $('[data-swap="' + target.dataset.swap + '"]', doc);
          if (source) target.innerHTML = source.innerHTML;
        });
      }).catch(function () {});
    }
    function applyVariant(variant) {
      setButtons(variant);
      if (!variant) return;
      var idInput = form ? $('[data-variant-id]', form) : null;
      if (idInput) idInput.value = variant.id;
      if (stickySelect) stickySelect.value = String(variant.id);
      if (variant.featured_media) { goToMedia(variant.featured_media.id, true); markThumb(variant.featured_media.id); }
      if (window.history.replaceState) {
        var params = new URLSearchParams(window.location.search);
        params.set('variant', variant.id);
        window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
      }
      refreshPrices(variant);
    }
    if (picker) {
      picker.addEventListener('change', function (event) {
        var options = selectedOptions();
        var fieldset = event.target.closest('fieldset');
        var label = fieldset ? $('[data-option-label]', fieldset) : null;
        if (label) label.textContent = event.target.value;
        markAvailability(options);
        applyVariant(findVariant(options));
      });
      markAvailability(selectedOptions());
    }
    if (stickySelect && picker) {
      stickySelect.addEventListener('change', function () {
        var variant = variants.find(function (v) { return String(v.id) === stickySelect.value; });
        if (!variant) return;
        $$('fieldset', picker).forEach(function (fieldset, i) {
          $$('input', fieldset).forEach(function (input) { input.checked = input.value === variant.options[i]; });
          var label = $('[data-option-label]', fieldset);
          if (label) label.textContent = variant.options[i];
        });
        markAvailability(variant.options);
        applyVariant(variant);
      });
    }

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', function (event) {
        if (event.submitter && event.submitter.name !== 'add' && !event.submitter.hasAttribute('data-sticky-button')) return;
        event.preventDefault();
        addToCart(form, $$('[data-add-button], [data-sticky-button]', scope), $('[data-form-error]', form));
      });
    }

    /* Sticky add-to-cart bar */
    var sticky = $('[data-sticky-atc]', scope);
    var mainButton = $('[data-add-button]', root);
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      var focusables = $$('select, button', sticky);
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        focusables.forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      }).observe(mainButton);
    }
  }

  /* Product recommendations ------------------------------------------------ */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (section) {
      if (!once(section, 'Recs') || section.innerHTML.trim() !== '') return;
      fetch(section.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = $('[data-recommendations]', doc);
        if (source && source.innerHTML.trim() !== '') section.innerHTML = source.innerHTML;
      }).catch(function () {});
    });
  }

  /* Cart page --------------------------------------------------------------- */
  function initCart() {
    var cart = $('[data-cart]');
    if (!cart || !once(cart, 'Cart')) return;
    cart.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      cart.style.opacity = '0.6';
      fetch(window.theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(input.dataset.line, 10), quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
    });
  }

  /* Collection filters & sorting ------------------------------------------- */
  function initFacets() {
    var form = $('[data-facets]');
    if (!form || !once(form, 'Facets')) return;
    form.addEventListener('change', function (event) {
      if (event.target.type === 'number') return;
      $$('input[type="number"]', form).forEach(function (input) { if (input.value === '') input.disabled = true; });
      form.submit();
    });
    form.addEventListener('submit', function () {
      $$('input[type="number"]', form).forEach(function (input) { if (input.value === '') input.disabled = true; });
    });
    document.addEventListener('click', function (event) {
      $$('details.facet[open]', form).forEach(function (d) { if (!d.contains(event.target)) d.removeAttribute('open'); });
    });
  }

  /* Collection: sort select outside the filter form, filters folded on small screens */
  function initCollectionSort() {
    $$('[data-facets-sort]').forEach(function (select) {
      if (!once(select, 'Sort')) return;
      select.addEventListener('change', function () {
        var facets = $('[data-facets]');
        var hidden = facets ? $('[data-facets-sort-value]', facets) : null;
        if (facets && hidden) {
          hidden.value = select.value;
          $$('input[type="number"]', facets).forEach(function (input) { if (input.value === '') input.disabled = true; });
          facets.submit();
        } else if (select.form) {
          select.form.submit();
        }
      });
    });
    $$('[data-filters]').forEach(function (details) {
      if (!once(details, 'Filters')) return;
      var wide = window.matchMedia('(min-width: 990px)');
      var sync = function () { if (wide.matches) details.setAttribute('open', ''); else details.removeAttribute('open'); };
      sync();
      if (wide.addEventListener) wide.addEventListener('change', sync);
      details.addEventListener('click', function (event) {
        if (wide.matches && event.target.closest('summary')) event.preventDefault();
      });
    });
  }

  /* Header extras: category dropdown in the search bar, compact state on scroll */
  function initHeaderExtras() {
    var header = $('[data-header]');
    if (!header || !once(header, 'Extras')) return;
    var dropdowns = $$('[data-dropdown]', header);
    document.addEventListener('click', function (event) {
      dropdowns.forEach(function (d) { if (d.open && !d.contains(event.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      dropdowns.forEach(function (d) {
        if (!d.open) return;
        d.removeAttribute('open');
        var summary = $('summary', d);
        if (summary) summary.focus();
      });
    });
    if (header.hasAttribute('data-compact')) {
      var wrapper = header.closest('.section-header') || header;
      var compact = false;
      var ticking = false;
      var update = function () {
        ticking = false;
        var y = window.pageYOffset || document.documentElement.scrollTop;
        var thr = window.innerWidth < 990 ? 120 : 220;
        if (!compact && y > thr) { compact = true; wrapper.classList.add('is-compact'); }
        else if (compact && y < 40) { compact = false; wrapper.classList.remove('is-compact'); }
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
      update();
    }
  }

  /* Hero slider --------------------------------------------------------------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      if (!once(slider, 'Slider')) return;
      var slides = $$('[data-slide]', slider);
      if (slides.length < 2) return;
      var current = 0;
      var counter = $('[data-slider-current]', slider);
      var show = function (index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
        if (counter) counter.textContent = String(current + 1);
      };
      var prev = $('[data-slider-prev]', slider);
      var next = $('[data-slider-next]', slider);
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (slider.hasAttribute('data-autoplay') && !reduce && !(window.Shopify && window.Shopify.designMode)) {
        var paused = false;
        slider.addEventListener('mouseenter', function () { paused = true; });
        slider.addEventListener('mouseleave', function () { paused = false; });
        slider.addEventListener('focusin', function () { paused = true; });
        slider.addEventListener('focusout', function () { paused = false; });
        window.setInterval(function () { if (!paused && !document.hidden) show(current + 1); }, 7000);
      }
      slider.addEventListener('shopify:block:select', function (event) {
        var index = slides.indexOf(event.target);
        if (index > -1) show(index);
      });
    });
  }

  /* Tabs ------------------------------------------------------------------------ */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      if (!once(root, 'Tabs')) return;
      var tabs = $$('[data-tab]', root);
      var panels = $$('[data-tab-panel]', root);
      var select = function (index, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) tab.removeAttribute('tabindex'); else tab.setAttribute('tabindex', '-1');
          if (panels[i]) panels[i].hidden = !on;
        });
        if (focus && tabs[index]) tabs[index].focus();
      };
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') { event.preventDefault(); select((i + 1) % tabs.length, true); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
        });
        tab.addEventListener('shopify:block:select', function () { select(i, false); });
      });
    });
  }


  /* Subscription quiz --------------------------------------------------------- */
  function initMarathon() {
    $$('[data-marathon]').forEach(function (root) {
      if (!once(root, 'Marathon')) return;
      var questions = $$('[data-marathon-question]', root);
      var bars = $$('[data-marathon-bar]', root);
      var counter = $('[data-marathon-counter]', root);
      var prev = $('[data-marathon-prev]', root);
      var next = $('[data-marathon-next]', root);
      var quiz = $('[data-marathon-quiz]', root);
      var result = $('[data-marathon-result]', root);
      var packages = $$('[data-marathon-package]', root);
      var KEY = 'lana-banana-marathon';
      var current = 0;
      var template = counter ? counter.textContent : '';
      function show(index) {
        current = Math.max(0, Math.min(index, questions.length - 1));
        questions.forEach(function (q, i) { q.hidden = i !== current; });
        bars.forEach(function (b, i) { b.classList.toggle('is-done', i <= current); });
        if (counter) counter.textContent = template.replace(/\d+/, String(current + 1));
        if (prev) prev.hidden = current === 0;
        if (next) next.textContent = current === questions.length - 1 ? next.dataset.finish : next.dataset.next;
        var first = $('input', questions[current]);
        if (first) questions[current].scrollIntoView({ block: 'nearest' });
      }
      function answers() {
        var out = [];
        questions.forEach(function (q) {
          var chosen = $$('input:checked', q);
          if (!chosen.length) return;
          out.push({ q: chosen[0].dataset.question, keys: chosen.map(function (c) { return c.value; }), labels: chosen.map(function (c) { return c.dataset.label; }) });
        });
        return out;
      }
      function finish() {
        var list = answers();
        var keys = [];
        list.forEach(function (a) { keys = keys.concat(a.keys); });
        var text = list.map(function (a) { return a.q + ': ' + a.labels.join(', '); }).join('\n');
        var day = '';
        list.forEach(function (a) { if (/avond|dag/i.test(a.q)) day = a.labels.join(', '); });
        var best = null, bestScore = -1;
        packages.forEach(function (p) {
          var want = (p.dataset.keys || '').split(',').map(function (k) { return k.trim(); }).filter(Boolean);
          var score = want.filter(function (k) { return keys.indexOf(k) > -1; }).length;
          p.classList.remove('is-proposed');
          var tag = $('[data-marathon-tag]', p); if (tag) tag.hidden = true;
          if (score > bestScore) { bestScore = score; best = p; }
          $$('[data-marathon-answers]', p).forEach(function (i) { i.value = text; });
          $$('[data-marathon-day]', p).forEach(function (i) { i.value = day; });
        });
        if (best) {
          best.classList.add('is-proposed');
          var t = $('[data-marathon-tag]', best); if (t) t.hidden = false;
          best.parentNode.insertBefore(best, best.parentNode.firstChild);
          var name = $('[data-marathon-proposal]', root); if (name) name.textContent = name.dataset.base + ' ' + best.dataset.name;
          var reason = $('[data-marathon-proposal-text]', root); if (reason) reason.textContent = best.dataset.reason || '';
        }
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
        quiz.hidden = true; result.hidden = false; result.scrollIntoView({ block: 'start' });
      }
      if (next) {
        next.dataset.next = next.textContent; next.dataset.finish = next.dataset.finishLabel || next.textContent;
        next.addEventListener('click', function () {
          if (!$$('input:checked', questions[current]).length) { questions[current].classList.add('is-empty'); return; }
          questions[current].classList.remove('is-empty');
          if (current === questions.length - 1) finish(); else show(current + 1);
        });
      }
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      var restart = $('[data-marathon-restart]', root);
      if (restart) restart.addEventListener('click', function () { result.hidden = true; quiz.hidden = false; show(0); quiz.scrollIntoView({ block: 'start' }); });
      var name = $('[data-marathon-proposal]', root); if (name) name.dataset.base = name.textContent;
      /* Antwoorden bewaren en terugzetten na vernieuwen */
      function save() {
        var state = questions.map(function (q) { return $$('input:checked', q).map(function (c) { return c.value; }); });
        try { localStorage.setItem(KEY + '-state', JSON.stringify(state)); } catch (e) {}
      }
      var restored = 0, complete = false;
      try {
        var state = JSON.parse(localStorage.getItem(KEY + '-state') || 'null');
        if (state && state.length === questions.length) {
          questions.forEach(function (q, i) { $$('input', q).forEach(function (input) { input.checked = state[i].indexOf(input.value) > -1; }); });
          complete = state.every(function (keys) { return keys.length > 0; });
          if (!complete) { state.some(function (keys, i) { if (!keys.length) { restored = i; return true; } return false; }); }
        }
      } catch (e) {}
      root.addEventListener('change', save);
      if (packages.length && !questions.length) { quiz.hidden = true; result.hidden = false; }
      else if (complete && packages.length) { finish(); window.scrollTo(0, 0); }
      else show(restored);
      if (window.location.hash === '#pakketten' && packages.length) { quiz.hidden = true; result.hidden = false; }
    });
  }


  /* Discreet kijken: productfoto's vervagen, keuze in localStorage --------------- */
  function initDiscreet() {
    var html = document.documentElement;
    var toggles = $$('[data-discreet-toggle]');
    function apply(on, store) {
      html.classList.toggle('is-discreet', on);
      toggles.forEach(function (t) {
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = on ? t.dataset.labelOff : t.dataset.labelOn;
        if (label) { t.setAttribute('aria-label', label); t.title = label; }
      });
      if (store) { try { localStorage.setItem('lana-banana-discreet', on ? '1' : '0'); } catch (e) {} }
    }
    toggles.forEach(function (t) {
      if (!once(t, 'Discreet')) return;
      t.addEventListener('click', function () { apply(!html.classList.contains('is-discreet'), true); });
    });
    apply(html.classList.contains('is-discreet'), false);
    $$('[data-age-discreet]').forEach(function (box) {
      if (!once(box, 'AgeDiscreet')) return;
      box.checked = html.classList.contains('is-discreet');
      box.addEventListener('change', function () { apply(box.checked, true); });
    });
    document.addEventListener('click', function (event) {
      var reveal = event.target.closest('[data-discreet-reveal]');
      if (reveal) { event.preventDefault(); apply(false, true); }
    });
  }


  /* Klantaccount: wachtwoord vergeten, adressen toevoegen en wijzigen --------------- */
  function initAccount() {
    var login = $('[data-login-form]'), recover = $('[data-recover-form]');
    if (login && recover && once(login, 'Recover')) {
      var swap = function (showRecover) { login.hidden = showRecover; recover.hidden = !showRecover; };
      $$('[data-recover-toggle]').forEach(function (b) { b.addEventListener('click', function () { swap(recover.hidden); }); });
      if ($('[data-recover-success]', recover) || window.location.hash === '#recover') swap(true);
    }
    $$('[data-address-toggle]').forEach(function (b) {
      if (!once(b, 'AddrToggle')) return;
      b.addEventListener('click', function () {
        var panel = $('[data-address-panel="' + b.dataset.addressToggle + '"]');
        if (panel) { panel.hidden = !panel.hidden; if (!panel.hidden) { var first = $('input', panel); if (first) first.focus(); } }
      });
    });
    $$('[data-address-delete]').forEach(function (b) {
      if (!once(b, 'AddrDelete')) return;
      b.addEventListener('click', function () {
        if (!window.confirm(b.dataset.confirm || '?')) return;
        var form = document.createElement('form');
        form.method = 'post'; form.action = window.theme.routes.addresses + '/' + b.dataset.addressDelete;
        form.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(form); form.submit();
      });
    });
    $$('[data-address-country]').forEach(function (country) {
      if (!once(country, 'Country')) return;
      var wrap = country.closest('.account__row'); var province = wrap ? $('[data-address-province]', wrap) : null; var pwrap = wrap ? $('[data-address-province-wrap]', wrap) : null;
      if (!province) return;
      var update = function () {
        var opt = country.options[country.selectedIndex]; var raw = opt ? opt.getAttribute('data-provinces') : null;
        var list = []; try { list = JSON.parse(raw || '[]'); } catch (e) {}
        province.innerHTML = list.map(function (p) { return '<option value="' + p[0] + '"' + (p[0] === province.dataset.default ? ' selected' : '') + '>' + p[1] + '</option>'; }).join('');
        if (pwrap) pwrap.hidden = list.length === 0;
      };
      if (country.dataset.default) { Array.prototype.forEach.call(country.options, function (o) { if (o.value === country.dataset.default || o.textContent === country.dataset.default) o.selected = true; }); }
      country.addEventListener('change', update); update();
    });
  }

  /* Countdown ------------------------------------------------------------------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      if (!once(el, 'Countdown')) return;
      var raw = (el.getAttribute('data-countdown') || '').trim().replace(' ', 'T');
      var end = new Date(raw).getTime();
      if (isNaN(end)) return;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var days = $('[data-countdown-days]', el);
      var hours = $('[data-countdown-hours]', el);
      var minutes = $('[data-countdown-minutes]', el);
      var timer;
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) { el.hidden = true; if (timer) window.clearInterval(timer); return; }
        var totalMinutes = Math.floor(left / 60000);
        if (days) days.textContent = pad(Math.floor(totalMinutes / 1440));
        if (hours) hours.textContent = pad(Math.floor((totalMinutes % 1440) / 60));
        if (minutes) minutes.textContent = pad(totalMinutes % 60);
        el.hidden = false;
      };
      tick();
      timer = window.setInterval(tick, 30000);
    });
  }

  function init() {
    initThemeToggle();
    initHeader();
    initQuantity();
    $$('[data-product]').forEach(initProduct);
    initRecommendations();
    initCart();
    initFacets();
    initCartDrawer();
    initQuickAdd();
    initAgeGate();
    initBackToTop();
    initHeaderExtras();
    initCollectionSort();
    initSliders();
    initTabs();
    initCountdowns();
    initMarathon();
    initDiscreet();
    initAccount();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Sexplace 1.0.0 */
(function () {
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  // promo code: copy + apply as discount
  $$('[data-promo-code]').forEach(function (el) {
    var code = el.getAttribute('data-promo-code'); var btn = $('[data-promo-apply]', el); if (!btn) return;
    var original = btn.textContent;
    btn.addEventListener('click', function () {
      try { navigator.clipboard && navigator.clipboard.writeText(code); } catch (e) {}
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      btn.textContent = el.getAttribute('data-copied') || original;
      setTimeout(function () { btn.textContent = original; }, 2000);
    });
  });
  // countdown
  $$('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown').trim().replace(' ', 'T'); var end = new Date(raw).getTime(); var out = $('[data-countdown-out]', el);
    if (!end || !out) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = end - Date.now(); if (d <= 0) { el.hidden = true; return; }
      var days = Math.floor(d / 864e5), h = Math.floor(d / 36e5) % 24, m = Math.floor(d / 6e4) % 60, s = Math.floor(d / 1e3) % 60;
      out.textContent = (days > 0 ? days + 'd ' : '') + pad(h) + 'u ' + pad(m) + 'm ' + pad(s) + 's';
    }
    tick(); setInterval(tick, 1000);
  });
  // collection: intro toggle, filter chips, view switch
  var intro = $('[data-intro]'), introBtn = $('[data-intro-toggle]');
  if (intro && introBtn) {
    if (intro.scrollHeight <= intro.clientHeight + 4) introBtn.hidden = true;
    introBtn.addEventListener('click', function () { var open = intro.classList.toggle('is-open'); introBtn.textContent = open ? introBtn.getAttribute('data-less') : introBtn.getAttribute('data-more'); });
  }
  $$('[data-filter-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var det = $('[data-filters]'); if (!det) return; det.open = true;
      var name = chip.getAttribute('data-filter-chip'); var target = null;
      if (name) { var input = $('[name^="' + name.replace(/"/g, '') + '"]', det) || $('[name="' + name + '"]', det); target = input ? input.closest('.facet-group') : null; }
      (target || det).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  var grid = $('[data-product-grid]'), switches = $$('.view-switch [data-view]');
  if (grid && document.querySelector('.collection--v4')) { grid.classList.remove('product-grid--list'); try { localStorage.setItem('sexplace-view', 'grid'); } catch (e) {} }
  else if (grid && switches.length) {
    var plaza = !!document.querySelector('.collection--plaza, .collection--v4');
    var key = 'sexplace-view', current = plaza ? 'grid' : 'list';
    try { current = localStorage.getItem(key) || current; } catch (e) {}
    if (plaza && window.innerWidth < 750) current = 'grid';
    function apply(v) { grid.classList.toggle('product-grid--list', v === 'list'); switches.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view') === v); }); }
    apply(current);
    switches.forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-view'); apply(v); try { localStorage.setItem(key, v); } catch (e) {} }); });
  }
})();
/* Sexplace 1.2.0: lokale verlanglijst, galerijpijlen, lees meer */
(function () {
  var KEY = 'sexplace-wish';
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var list = load();
  document.querySelectorAll('[data-wish]').forEach(function (btn) {
    var h = btn.getAttribute('data-wish');
    btn.setAttribute('aria-pressed', list.indexOf(h) > -1 ? 'true' : 'false');
    btn.addEventListener('click', function (e) {
      e.preventDefault(); list = load(); var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      save(list); btn.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
    });
  });
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var viewer = root.querySelector('[data-gallery-viewer]'); if (!viewer) return;
    function go(dir) { viewer.scrollBy({ left: dir * viewer.clientWidth, behavior: 'smooth' }); }
    var n = root.querySelector('[data-gallery-next]'), p = root.querySelector('[data-gallery-prev]');
    if (n) n.addEventListener('click', function () { go(1); });
    if (p) p.addEventListener('click', function () { go(-1); });
  });
  document.querySelectorAll('[data-readmore-toggle]').forEach(function (btn) {
    var box = btn.previousElementSibling;
    while (box && !box.hasAttribute('data-readmore')) box = box.previousElementSibling;
    if (!box) box = btn.parentElement && btn.parentElement.querySelector('[data-readmore]');
    if (!box) return;
    btn.addEventListener('click', function () { var open = box.classList.toggle('is-open'); btn.textContent = (open ? btn.getAttribute('data-less') : btn.getAttribute('data-more')) + (open ? ' ⌃' : ' ⌄'); });
    function fits() { if (!box.classList.contains('is-open') && box.scrollHeight <= box.clientHeight + 8) { btn.hidden = true; box.classList.add('is-open'); } }
    fits(); window.addEventListener('load', fits);
  });
})();
/* Sexplace 1.3.0: vergroten + puntjes */
(function () {
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var viewer = root.querySelector('[data-gallery-viewer]'); if (!viewer) return;
    var slides = viewer.querySelectorAll('.gallery__slide'); if (slides.length > 1) {
      var dots = document.createElement('div'); dots.className = 'gallery__dots';
      slides.forEach(function (_, i) { var d = document.createElement('span'); if (i === 0) d.className = 'is-active'; dots.appendChild(d); });
      (root.querySelector('.gallery__frame') || root).appendChild(dots);
      viewer.addEventListener('scroll', function () {
        var i = Math.round(viewer.scrollLeft / viewer.clientWidth);
        dots.querySelectorAll('span').forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
    }
    var enlarge = root.querySelector('[data-gallery-enlarge]');
    if (enlarge) enlarge.addEventListener('click', function () {
      var i = Math.round(viewer.scrollLeft / viewer.clientWidth); var s = slides[i] || slides[0];
      var z = s && s.querySelector('[data-zoom]'); if (z) z.click();
    });
  });
})();
/* Sexplace 1.3.2: koopkaartje onder de header, onderbalk vrij van de tekst */
(function () {
  var header = document.querySelector('[data-header]');
  function setHeaderVar() {
    var h = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--sticky-header-h', Math.round(h) + 'px');
  }
  setHeaderVar(); window.addEventListener('resize', setHeaderVar);
  if (document.querySelector('.product__side-card')) document.body.classList.add('has-side-card');
  var bar = document.querySelector('[data-sticky-atc]');
  if (bar) {
    var obs = new MutationObserver(function () {
      var vis = bar.classList.contains('is-visible') && getComputedStyle(bar).display !== 'none';
      document.body.classList.toggle('has-sticky-bar', vis);
    });
    obs.observe(bar, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* Sexplaza: filterlade op collectiepagina */
(function () {
  var plaza = document.querySelector('.collection--plaza, .collection--v4'); if (!plaza) return;
  var drawer = plaza.querySelector('[data-filter-drawer]'); var overlay = plaza.querySelector('.collection-overlay'); if (!drawer) return;
  var det = drawer.querySelector('[data-filters]'); if (det) det.open = true;
  function open() { drawer.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  plaza.querySelectorAll('[data-filter-chip]').forEach(function (c) { c.addEventListener('click', function (e) { e.stopImmediatePropagation(); open(); }, true); });
  plaza.querySelectorAll('[data-filter-drawer-close]').forEach(function (c) { c.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
/* Sexplaza: bundel toevoegen + tabs */
(function () {
  document.querySelectorAll('[data-bundle]').forEach(function (box) {
    var btn = box.querySelector('[data-bundle-add]'); if (!btn) return;
    btn.addEventListener('click', function () {
      var items = box.getAttribute('data-ids').split(',').map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      btn.disabled = true; var t = btn.textContent; btn.textContent = '…';
      var done = function () { btn.textContent = '✓ Toegevoegd'; setTimeout(function () { btn.textContent = t; btn.disabled = false; }, 2500); };
      var fail = function () { btn.textContent = t; btn.disabled = false; };
      if (window.theme && window.theme.addItems) { window.theme.addItems(items).then(done).catch(fail); }
      else { fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function () { window.location.href = '/cart'; }).catch(fail); }
    });
  });
  var bar = document.querySelector('[data-panel-tabs]'); if (!bar) return;
  var panels = Array.prototype.slice.call(document.querySelectorAll('.product__panel[data-panel]'));
  panels.forEach(function (p, i) {
    var a = document.createElement('a'); a.href = '#' + p.id; a.className = 'product__tab' + (i === 0 ? ' is-active' : ''); a.textContent = p.getAttribute('data-panel');
    a.addEventListener('click', function (e) { e.preventDefault(); var top = p.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-h')) || 80) - 70; window.scrollTo({ top: top, behavior: 'smooth' }); });
    bar.appendChild(a);
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { bar.querySelectorAll('.product__tab').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('href') === '#' + en.target.id); }); } }); }, { rootMargin: '-40% 0px -55% 0px' });
    panels.forEach(function (p) { io.observe(p); });
  }
})();
/* Sexplaza 1.0.4: headerhoogte live bijhouden (compacte header) */
(function () {
  var header = document.querySelector('[data-header]'); if (!header || !('ResizeObserver' in window)) return;
  var ro = new ResizeObserver(function () { document.documentElement.style.setProperty('--sticky-header-h', Math.round(header.getBoundingClientRect().height) + 'px'); });
  ro.observe(header);
})();
